import React from "react";
import "./DeleteButton.css";

const DeleteButton = ({onClick, label, icon, hoverIcon}) => {
  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <button className="delete-button-frame" onClick={onClick} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
      <div className="delete-button-div">
        <img className="delete-button-vector" alt="Vector" src={isHovered && hoverIcon ? hoverIcon : icon} />
        <div className="delete-button-text-wrapper">{label}</div>
      </div>
    </button>
  );
};


export default DeleteButton;